import config from '../../config';
import storage from '../../utils/storage';
import { buildURLWithUTMParams } from '../handle-route.service';
import ScoutConnectService from '../hr9/hr9.services';
import ApiServices from './api.authen';

// Browser-compatible SHA-256 implementation
const sha256 = async (message: string): Promise<string> => {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return btoa(String.fromCharCode(...hashArray));
};

export default function AuthenMysa() {
    const PKCEencoding = async (verificationCode: string): Promise<string> => {
        let result = await sha256(verificationCode);
        
        result = result.replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
        return result;
    }

    const randomString = (length: number) => {
        var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var result = '';
        for (var i = 0; i < length; i++) {
            result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
        }
        return result;
    }

    return {
        async authenticateUrl(utmSource: string, utmMedium: string, feature: string) {
            const codeVerifier = randomString(56);
            const codeChallenge = await PKCEencoding(codeVerifier);
            const newURL = buildURLWithUTMParams(config.authen.redirect_uri, utmSource, utmMedium, feature, 'LOGIN');
            localStorage.setItem(storage.code_verifier, codeVerifier);
            const state = randomString(Number(config.authen.length));
            const urlReturn = config.authen.sso_url + "?" + new URLSearchParams({
                redirect_uri: newURL,
                state: state,
                code_challenge: codeChallenge,
                response_type: 'code',
                code_challenge_method: 'S256',
                client_id: config.authen.client_id + ""

            })
            console.log(urlReturn)
            window.open(urlReturn, "_self");
        },
        async authenticateUrlRegister(utmSource: string, utmMedium: string, feature: string) {
            const codeVerifier = randomString(56);
            const codeChallenge = await PKCEencoding(codeVerifier);
            const newURL = buildURLWithUTMParams(config.authen.redirect_uri, utmSource, utmMedium, feature, 'LOGIN');
            localStorage.setItem(storage.code_verifier, codeVerifier);
            const state = randomString(Number(config.authen.length));
            const urlReturn = config.authen.sso_url + "/register/email" + "?" + new URLSearchParams({
                redirect_uri: newURL,
                state: state,
                code_challenge: codeChallenge,
                response_type: 'code',
                code_challenge_method: 'S256',
                client_id: config.authen.client_id + ""

            })
            console.log(urlReturn)
            window.open(urlReturn, "_self");
        },
        async checkCode(code: string, codeVerifier: string, utmSource: string, utmMedium: string, feature: string) {
            this.getAccessToken(code, codeVerifier, utmSource, utmMedium, feature);
        },
        async getAccessToken(code: string, codeVerifier: string, utmSource: string, utmMedium: string, feature: string) {
            const newURL = buildURLWithUTMParams(config.authen.redirect_uri, utmSource, utmMedium, feature, 'LOGIN');
            return ApiServices().oauthToken(code, codeVerifier, newURL).then(res => res).catch(err => console.log(err))
        },
        async getProfile() {
            return ScoutConnectService.getProfile().then(res => res).catch(err => console.log(err))
        },
        async registerProfile() {
            return ScoutConnectService.registerProfile().then(res => res).catch(err => console.log(err))
        },
        async registerCompany() {
            return ScoutConnectService.registerCompany().then(res => res).catch(err => console.log(err))
        },
        async LogOut() {
            // ✅ Clear all cookies
            window.open(config.authen.sso_url+`/logout?client_id=${config.authen.client_id}&lang=th&redirect_uri=${encodeURIComponent(config.home_url+"")}`, "_self")
            return true;
        }
    }
}